@if(!isPlain) {
  <mat-form-field appearance="outline" class="w-100">
    <input type="text" matInput [formControl]="form" [matAutocomplete]="auto" class="general-text-5 default-inp" [placeholder]="placeholder" [matTooltip]="form.value || ''" (focus)="onInputFocus()">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option" [matTooltip]="option">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
} @else {
  <form class="autocomplete-form">
    <input 
      type="text"
      [placeholder]="placeholder"
      [formControl]="form"
      [matAutocomplete]="auto"
      [matTooltip]="form.value || ''"
      class="form-control"
      (focus)="onInputFocus()">
    <mat-autocomplete #auto="matAutocomplete">
      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option" [matTooltip]="option">{{option}}</mat-option>
      }
    </mat-autocomplete>
  </form>
}
